// reducers/examReducer.js
export const examReducer = (state = { exams: [] }, action) => {
  switch (action.type) {
    case "EXAM_REQUEST":
    case "MARKS_REQUEST":
      return { ...state, loading: true };
    case "GET_EXAMS_SUCCESS":
      return { loading: false, exams: action.payload };
    case "CREATE_EXAM_SUCCESS":
      return { loading: false, success: true };
    case "GET_STUDENT_MARKS_SUCCESS":
      return { loading: false, marks: action.payload };
    case "GET_CLASS_MARKS_SUCCESS":
      return { loading: false, classMarks: action.payload };
    case "ENTER_MARKS_SUCCESS":
      return { loading: false, success: true };
    case "EXAM_REPORT_SUCCESS":
      return { loading: false, report: action.payload };
    case "EXAM_FAIL":
    case "MARKS_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
